import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataFileImportDto, SampleValidationLine } from '../../service/dto';
import { concatMap, filter, forkJoin, merge, Subscription, timer } from 'rxjs';
import { HttpDataFileImportService } from '../../service/http-data-file-import.service';
import { AuthService } from '../../service/auth.service';
import { ActivatedRoute } from '@angular/router';
import { faArrowsTurnToDots, faCheckCircle, faClockRotateLeft, faFileShield, faGear, faKey, faXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImportViewEncryptionKeyComponent } from './components/import-view-encryption-key/import-view-encryption-key.component';

@Component({
	selector: 'app-import-view',
	templateUrl: './import-view.component.html',
	styleUrl: './import-view.component.scss',
	standalone: false
})
export class ImportViewComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	data!: DataFileImportDto;
	uploadProgress!: number;
	faCheckCircle = faCheckCircle;
	faXmark = faXmark;
	faClockRotateLeft = faClockRotateLeft;
	faFileShield = faFileShield;
	faGear = faGear;
	faArrowsTurnToDots = faArrowsTurnToDots;
	faKey = faKey;
	samples!: SampleValidationLine[];

	constructor(
		private service: HttpDataFileImportService,
		private authService: AuthService,
		private activatedRoute: ActivatedRoute,
		private modalService: NgbModal) { }

	ngOnInit(): void {
		this.subscription.add(
			merge(this.activatedRoute.paramMap, timer(100, 2000))
				.pipe(
					filter(() => this.authService.isAuthenticated()),
					concatMap(() => {
						const importId = +this.activatedRoute.snapshot.paramMap.get('importId')!;
						return forkJoin({
							data: this.service.get(importId),
							samples: this.service.getSamples(importId),
						});
					})
				)
				.subscribe(({ data, samples }) => {
					this.data = data;
					this.samples = samples;
				})
		);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	doDownloadRejections() {
		this.service.doDownloadRejections(this.data.id).subscribe();
	}
	doDownloadOriginal() {
		this.service.doDownloadOriginal(this.data.id).subscribe();
	}
	doViewDecryptionKey() {
		const instance = this.modalService.open(ImportViewEncryptionKeyComponent);
		instance.componentInstance.data = this.data;
	}
}
